import type { ProgramConfig } from '../types/schema';

export function resolveEnrollmentProduct(config: ProgramConfig | undefined, product: string | undefined) {
  if (!product || config?.solution !== 'multi-product-copay-enrollment'
    || !Object.prototype.hasOwnProperty.call(config.products, product)) {
    return null;
  }
  const selected = config.products[product];
  return {
    pages: selected.pages,
    effectiveConfig: selected.theme ? {
      ...config,
      theme: {
        ...config.theme,
        ...selected.theme,
        colors: { ...config.theme.colors, ...selected.theme.colors },
      },
    } : config,
  };
}

export function buildSubmissionResultPath(siteType: 'enrollments' | 'escalations', resultId: string, product?: string): string {
  const productPath = product ? `/${encodeURIComponent(product)}` : '';
  return `/${siteType}${productPath}/result/${encodeURIComponent(resultId)}`;
}

// Public result links carry the bearer token in the URL fragment, which browsers never send to
// servers, logs, or Referer headers. The result page reads it and sends it in a POST body.
export function buildPublicResultPath(product: string, token: string): string {
  return `/enrollments/${encodeURIComponent(product)}/result#token=${encodeURIComponent(token)}`;
}

export function readPublicResultToken(hash: string): string {
  return new URLSearchParams(hash.replace(/^#/, '')).get('token')?.trim() ?? '';
}

export function buildEnrollmentFormPath(product?: string): string {
  return product ? `/enrollments/${encodeURIComponent(product)}` : '/enrollments';
}
